import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { get_backlog_from_redux, get_sample_types } from '../../../../redux/po_backlog/backlog.selector';
import { Box, Button, Tab, Tabs } from '@mui/material';
import { generateExcel } from './utils/download_backlog_excel';
import OptimusTabPanel from '../../../../common/components/TabUI/TabPanel';
import BacklogTable from './components/BacklogTable';
import { mixpanelTrackTabs, mixpanelTrackTabsButton } from '../../../../mixPanelFunctions/mixPanelFunctions';

const AllBacklogs = ({ hidden_fields }) => {
  // Getting Sample Types
  const sample_types = useSelector(get_sample_types);

  // States to manage tabs
  const [backlogTabValue, setBacklogTabValue] = useState(0);

  const handleBacklogTabChange = (event, newValue) => {
    setBacklogTabValue(newValue);
    // navigate(`/input/daily/${newValue === 0 ? "po" : "backlog"}${targeted_date_for_completion_of_analysis ? `?targeted_date_for_completion_of_analysis=${targeted_date_for_completion_of_analysis}` : ``}`);
  };

  // Getting the backlog data
  const backlog = useSelector(get_backlog_from_redux);
  
  useEffect(()=>{
    if(sample_types && sample_types?.length > 0){
      mixpanelTrackTabs(sample_types[backlogTabValue] === "CB" ? "In Process" : sample_types[backlogTabValue] === "FP" ? "FP Pack" : sample_types[backlogTabValue],"home page sample status")
    }
  },[backlogTabValue])

  return (
    <div>
      <Box className="flex justify-between items-baseline w-full">
        <Tabs
          className='flex-1'
          sx={{
            borderBottom: '1px solid #e8e8e8',
            '& .MuiTabs-indicator': {
              backgroundColor: '#084298',
              display: "flex",
              justifyContent: "center"
            },
            '& .MuiTabs-indicatorSpan': {
              maxWidth: 40,
              width: '100%',
              // backgroundColor: '#635ee7',
            },
          }}
          value={backlogTabValue}
          onChange={handleBacklogTabChange}
          variant="scrollable"
          scrollButtons={false}
          aria-label="scrollable prevent tabs example"
        >
          {
            sample_types?.map(sample_type => <Tab disableRipple label={sample_type === "CB" ? "In Process" : sample_type === "FP" ? "FP Pack" : sample_type} key={`Sample Status Tab - ${sample_type}`} />)
          }
          {/* <Tab disableRipple label="in process" />
        <Tab disableRipple label="INTM" />
        <Tab disableRipple label="fp PACK" /> */}
        </Tabs>
        <Box>
          <Box>
            <Button onClick={() => {
              generateExcel(sample_types[backlogTabValue]);
              mixpanelTrackTabsButton(sample_types[backlogTabValue] === "CB" ? "In Process" : sample_types[backlogTabValue] === "FP" ? "FP Pack" : sample_types[backlogTabValue],"download","home page sample status")
            }}>Download Excel</Button>
          </Box>
        </Box>
      </Box>
      {
        sample_types && sample_types.map((sample_type, idx) =>
          <OptimusTabPanel
            value={backlogTabValue}
            index={idx}
            key={`SampleStatusTable-${sample_type}-${idx}`} >
            <Box sx={{ bgcolor: "white" }}
            >
              <Box className="col-span-3"></Box>
              {
                backlog && backlog?.[sample_type] && backlog?.[sample_type]?.table_data &&
                <BacklogTable
                  columns={backlog?.[sample_type].columns}
                  table_data={backlog?.[sample_type].table_data}
                  category={sample_type}
                  hidden_fields={hidden_fields}
                />
              }
            </Box>
          </OptimusTabPanel>)
      }
      {/* <OptimusTabPanel value={backlogTabValue} index={1} >
            <Box sx={{ bgcolor: "white" }}>
              <Box className="col-span-3">
                {
                  state.backlog.intm && state.backlog.intm.table_data && state.backlog.intm.table_data.length > 0 &&
                  <BacklogTable
                    columns={state.backlog.intm.columns}
                    table_data={state.backlog.intm.table_data}
                    category='INTM'
                  />
                }
              </Box>
            </Box>
          </OptimusTabPanel> */}
    </div>
  );
};

export default AllBacklogs;